var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideUserImg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3898 21.1098C27.2296 21.1098 28.0351 21.4434 28.6289 22.0373C29.2228 22.6312 29.5564 23.4366 29.5564 24.2765V25.0312C29.5564 28.8069 25.1125 31.6654 19.0009 31.6654C12.8892 31.6654 8.44531 28.9558 8.44531 25.0312V24.2765C8.44531 23.4366 8.77894 22.6312 9.37281 22.0373C9.96667 21.4434 10.7721 21.1098 11.612 21.1098H26.3898ZM19.0009 6.33203C19.8326 6.33203 20.6561 6.49585 21.4245 6.81413C22.1929 7.13241 22.8911 7.59892 23.4792 8.18702C24.0673 8.77513 24.5338 9.47331 24.8521 10.2417C25.1704 11.0101 25.3342 11.8337 25.3342 12.6654C25.3342 13.4971 25.1704 14.3206 24.8521 15.089C24.5338 15.8574 24.0673 16.5556 23.4792 17.1437C22.8911 17.7318 22.1929 18.1983 21.4245 18.5166C20.6561 18.8349 19.8326 18.9987 19.0009 18.9987C17.3212 18.9987 15.7103 18.3314 14.5225 17.1437C13.3348 15.956 12.6675 14.3451 12.6675 12.6654C12.6675 10.9857 13.3348 9.37475 14.5225 8.18702C15.7103 6.99929 17.3212 6.33203 19.0009 6.33203Z",
    fill: "#CAE8DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideUserImg2);
export default __webpack_public_path__ + "static/media/side-user-img2.80649f8a7eb4f6075db29fc24760cb3e.svg";
export { ForwardRef as ReactComponent };